module.exports = __webpack_public_path__ + "img/your.2d4a9722.svg";